import React from 'react';
import {useThemeContext} from '../../../../../context';
import {Button} from '../../../../common';

const PaymentMethod = ({firstBtn, fourBtn, secondBtn, thirdBtn, selected}) => {
    const {theme} = useThemeContext();
    const renderButton = btn => {
        return (
            <Button
                className={`paymentmethodButton`}
                title={btn?.title}
                type="buttonTitleIcon"
                backgroundColor={selected === btn?.title.toLowerCase() ? theme.barclaysBlue : theme.seperatorTwo}
                icon_name={btn?.icon}
                handleClick={btn?.action}
                icon_fill={theme.white}
                icon_width={'24'}
                icon_height={'24'}
                icon_viewBox={'0 0 24 24'}
            />
        );
    };

    return (
        <div className="paymentmethodBox width100">
            {firstBtn && renderButton(firstBtn)}
            {secondBtn && renderButton(secondBtn)}
            {thirdBtn && renderButton(thirdBtn)}
            {fourBtn && renderButton(fourBtn)}
        </div>
    );
};

export default PaymentMethod;
